import { AppBar } from "./AppBar.tsx";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Button from "@mui/material/Button";
import { Link as RouterLink } from "react-router";
import { trackEvent } from "../util/analytics.ts";
import { EventCategory } from "@labs/shared/types/EventCategory.ts";

type TopNavProps = {
  open: boolean;
  handleDrawerOpen: () => void;
};
export const TopNav = ({ open, handleDrawerOpen }: TopNavProps) => (
  <AppBar position="fixed" open={open}>
    <Toolbar>
      <Box sx={{ display: "flex", width: "100%" }}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          sx={[
            {
              mr: 2,
            },
            open && { display: "none" },
          ]}
        >
          <MenuIcon />
        </IconButton>
        <a
          href={"https://cascadeenergy.com"}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Box
            component="img"
            src={"/cascadeLogoBare.svg"}
            alt="Cascade Energy logo"
            sx={{
              alignSelf: "center",
              width: "168px",
              height: "100%",
            }}
          />
        </a>
        <Button
          sx={{ marginLeft: "auto" }}
          component={RouterLink}
          to="/contact-us"
          variant="outlined"
          onClick={() =>
            trackEvent(
              EventCategory.LeadGen,
              "Clicked Link",
              window.location.href,
            )
          }
        >
          Get In Touch
        </Button>
      </Box>
    </Toolbar>
  </AppBar>
);
